import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { ICheckupTypeModel } from "@/model";

/**
 * 文件服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class FileService extends ServiceBase {

    /**
     * 上传
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async upload(data: any): Promise<IHttpResponse> {
        let response = await this.apis.upload({ 
            data:data
         });
        return response;
    }

    /**
     * 添加/编辑文件夹
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async operationDirectory(data: any): Promise<IHttpResponse>
     {
        let response;
        if(data.id)
        {
            response = await this.apis.editDirectory({ data });
        }
        else
        {
            response = await this.apis.addDirectory({ data });
        }
        
        return response;
    }

    /**
     * 获取文件夹列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getDirectoryList(useType: number): Promise<IHttpResponse>
     {
        let response = await this.apis.getDirectoryList({ data:{
            useType
        } });
        
        return response;
    }

    /**
     * 删除文件夹(文件类型)
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async deleteDirectory(id: number): Promise<IHttpResponse>
     {
        let response = await this.apis.deleteDirectory({ 
            urlPath: {id}
         });
        
        return response;
    }

    /**
     * 获取文件夹详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getDirectoryDetail(data: any): Promise<IHttpResponse>
     {
        let response = await this.apis.getDirectoryDetail({ 
            data: data
        });
        
        return response;
    }

    /**
     * 删除文件
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async delFile(id: number): Promise<IHttpResponse>
     {
        let response = await this.apis.delFile({ 
            urlPath:{
                id
            }
        });
        
        return response;
    }


}